// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"881":"2d431751","1880":"2d431751","3251":"9b79cbba","3616":"2d431751","5491":"2d431751","6985":"2d431751","8488":"86454a2c","8685":"2d431751"}[chunkId] + ".chunk.css";
};